export default "__VITE_ASSET__DUdIq3Gt__"